import { motion } from "framer-motion";
import { IMAGES, reveal } from "@/components/store/data";

const CHAPTERS = [
  {
    n: "01",
    title: "Why Ubiquinol",
    body: "CoQ10 exists in two forms. Ubiquinol is the reduced, active form — the one your body absorbs most efficiently and uses directly to power the mitochondria inside every cell.",
  },
  {
    n: "02",
    title: "Cellular Energy",
    body: "Your heart, brain and muscles are energy-hungry. Ubiquinol is essential to ATP production, the fuel that keeps these vital organs performing at their peak.",
  },
  {
    n: "03",
    title: "Antioxidant Defense",
    body: "As a potent fat-soluble antioxidant, Ubiquinol helps neutralise free radicals and protect cells from oxidative stress that accelerates ageing.",
  },
];

export default function Manifesto() {
  return (
    <section id="manifesto" className="relative py-28 md:py-40">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-14">
        <div className="lg:col-span-5">
          <div className="sticky top-28">
            <motion.p
              variants={reveal}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              className="text-xs uppercase tracking-[0.25em] text-[#D4AF37] mb-6"
            >
              The Science
            </motion.p>
            <motion.h2
              variants={reveal}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tight text-[#F4F1EB]"
            >
              Vitality, engineered at the cellular level.
            </motion.h2>
            <motion.div
              variants={reveal}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              className="mt-10 overflow-hidden rounded-sm border border-white/10"
            >
              <img src={IMAGES.lifestyle} alt="Wellness lifestyle" className="w-full h-72 object-cover" />
            </motion.div>
          </div>
        </div>

        <div className="lg:col-span-7 flex flex-col gap-14 lg:pt-4">
          {CHAPTERS.map((c, i) => (
            <motion.div
              key={c.n}
              variants={reveal}
              custom={i}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, amount: 0.5 }}
              className="border-t border-white/10 pt-8"
            >
              <div className="flex items-baseline gap-6">
                <span className="font-display text-2xl text-[#D4AF37]">{c.n}</span>
                <div>
                  <h3 className="font-display text-2xl md:text-3xl text-[#F4F1EB] mb-3">{c.title}</h3>
                  <p className="text-[#B8C5C4] leading-relaxed max-w-xl">{c.body}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
